import React, { useEffect, useRef, useState } from 'react';
import './Hotspots.css';

import { Label } from './Label';

import { store } from '../Store';
import classNames from 'classnames';

import lottie from 'lottie-web';

export function Hotspot(props) {

  const [isHovering, setIsHovering] = useState(false);
  const [animation, setAnimation] = useState(null);

  const size = 84;
  const posX = props.x - (size / 2);
  const posY = props.y - (size / 2);
  const style = { transform: 'translate3d(' + posX + 'px, ' + posY + 'px, 0)', transitionDelay: props.transitionDelay + 'ms' };


  const handleClickhotspot = id => {
    store.setCurrentHotspot(id);
    store.setCurrentPanelHotspot(id);
    store.setHotspotPanelVisible(true);
    store.setPlayAnimation(true);
  };

  const handleMouseEnter = () => {
    const wWidth = window.innerWidth;
    store.setHotspotPanelOrigin(posX - (wWidth / 2) + (size / 2), posY + (size / 2));

    setIsHovering(true);

    if (animation && !window.MOBILE) {
      animation.play();
      animation.loop = true;
      animation.setSpeed(1);
    }
  };

  const handleMouseLeave = () => {
    setIsHovering(false);

    if (animation && !window.MOBILE) {
      var isPastHalf = animation.currentFrame / animation.totalFrames > 0.5;

      // Finish the animation at triple speed until we reach the first or last frame, whichever is closest in time.
      animation.loop = false;
      animation.setSpeed(isPastHalf ? 3 : -3);
    }
  };

  // const hasAnimatedIcon = props.id !== "hotspot_scanning";
  const hasAnimatedIcon = props.id;

  const renderStaticIcon = id => {
    if (id === undefined) {
      return;
    }

    const imageId = id.split('_').pop();
    const imagePath = 'hotspot-icons/' + imageId + '.png';
    const imagePath2x = 'hotspot-icons/' + imageId + '@2x.png';

    return (
      <img src={imagePath} srcSet={`${imagePath}, ${imagePath2x} 2x`} alt="imageId" />
    )
  };

  const iconEl = useRef(null);

  useEffect(() => {
    if (!animation && hasAnimatedIcon) {
      setAnimation(lottie.loadAnimation({
        container: iconEl.current,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: 'assets/animations/' + props.id + '.json'
      }));
    }
  }, []);

  return (
    <div 
      className={classNames('hotspot', { 'visible': props.visible })}
      onClick={() => handleClickhotspot(props.id)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={style}
    >
      {hasAnimatedIcon ? (
        <div ref={iconEl} className="lottie-icon"></div>
      ) : (
        renderStaticIcon(props.id)
      )}
      <Label visible={isHovering && !window.MOBILE} starred={props.visited}>{props.title}</Label>
    </div>
  )
}